import { useMemo } from 'react';
import { ScopeEnum } from 'src/domain';
import { useScope } from 'src/hooks/useScope';
import { EntityTypeEnum } from 'src/infrastructure/rest-api/api-types';
import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useSplitLevelApiQuery = (entityId: number | string | null | undefined, entityType: EntityTypeEnum) => {
    const scope = useScope();

    const scopeMatches = useMemo(() => {
        switch (entityType) {
            case 'Store':
                return scope === ScopeEnum.STORE;
            case 'Cluster':
                return scope === ScopeEnum.CLUSTER;
            case 'Partner':
                return scope === ScopeEnum.PARTNER;
            default:
                return false;
        }
    }, [entityType, scope]);

    const entityIdAsNumber = Number(entityId);
    const { data, loading, error } = useApiQuery('/api/inheritance', 'get', {
        query: {
            entityId: entityIdAsNumber,
            entityType,
        },
        enabled: entityId !== null && !Number.isNaN(entityIdAsNumber) && scopeMatches,
    });

    return { data, loading, error };
};
